/**
 * Constructs a localization data object by parsing either a moniker or BCP-47
 * language tag. The constructed object will be composed of the following
 * properties:
 *      data: Original passed in value.
 *      brand: Brand variant (eg. HA, VRBO).
 *      code: BCP-47 style validated language tag (ie. no brand variant).
 *      language: The language of the locale (ie. en). ISO 639.
 *      region: The country code (ie. US). ISO 3166-1.
 * @param {string} locale - A moniker or BCP-47 language code.
 */
function LanguageTag(locale) {
    locale = locale ? locale.trim() : '';
    const tags = locale.split(/_|-/);

    this.data = locale;
    this.language = tags[0] && tags[0].length === 2 ? tags[0] : null;
    this.region = tags.length > 1 && tags[1] && tags[1].length === 2 ? tags[1] : null;
    this.brand = tags.length > 2 && tags[2] ? tags[2] : null;

    // Validate a BCP-47 style language tag based on the language and region.
    try {
        let code = this.language && this.region ? `${this.language}-${this.region}` : this.language;
        const validLocale = Intl.DateTimeFormat.supportedLocalesOf([code]);
        this.code = validLocale && validLocale.length === 1 ? validLocale[0] : null;
    } catch (e) {
        // Ignore error, code will be undefined.
    }
}

module.exports = LanguageTag;
